<div class="col-12 mt-2">
  <div class="col-12 flex p-0">
    <div class="col-10 p-0">
      <div class="col-12 p-0">
        <div class="col-2 p-0">
          <button pButton label="Refresh" icon="fa fa-refresh" class="buttonsRound" (click)="refreshViews()"
            [disabled]="!selectedSequencerType"></button>
        </div>
        <div class="col-10 p-0 text-center">
          <div class="col-4">
          </div>
          <div class="ui-inputgroup">
            <button pButton class="theme-button labelButton" type="button" label="Sequencer Type" style="height: 2.5rem;"></button>
            <p-dropdown [style]="{'width':'15em', 'maxWidth':'15em','height':'2.5rem'}" [options]="sequencerOptions"
              [(ngModel)]="selectedSequencerType" placeholder="Select" (onChange)="getDataFromBackEnd()"></p-dropdown>
          </div>
        </div>
      </div>
      <div class="col-12 p-0">
        <div class="col-12 p-0 mt-3">
          <p-confirmDialog appendTo="body"></p-confirmDialog>
          <p-table class="text-center" [value]="unscheduledTableData" [columns]="unscheduledTableColumns"
            [scrollable]="true" [style]="{'overflow':'visible', 'word-wrap': 'break-word'}"
            [scrollHeight]="unscheduledTableScrollheight" [loading]="unscheduledTableLoading"
            (sortFunction)="sortUnscheduledTableData($event)" [customSort]="true">
            <ng-template pTemplate="caption">
              <table style="border: none;" aria-describedby="table to format">
                <thead>
                  <th class="text-right">
                    <label style="font-size: large;">Unscheduled Data</label>
                  </th>
                  <th class="text-right">
                    <em class="fa fa-search"></em>
                    <input type="text" pInputText size="40" placeholder="Global Filter"
                      [(ngModel)]="unschduledfiltervalue" (input)="unScheduleGlobalFilter($event.target.value)"
                      style="width:auto">
                  </th>
                </thead>
              </table>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th scope="col" *ngFor="let col of columns" class="text-center" [ngStyle]="{'width' : col.width}"
                  [pSortableColumn]="col.field">
                  {{col.header}}
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
              <tr [class]="unscheduleRunId == rowData['runId'] ? 'unscheduledRun' : null">
                <ng-container *ngFor="let col of columns">
                  <td *ngIf="col.field == 'runId'" [ngStyle]="{'width' : col.width}">
                    <a [routerLink]="['/runprocess', rowData['runId']]">{{rowData['runId']}}</a>
                  </td>
                  <td *ngIf="col.field == 'flowcellConfig'" [ngStyle]="{'width' : col.width}">
                    {{rowData['flowCellName'] + " " + rowData['largestReadMode']}}
                  </td>
                  <td *ngIf="col.field == 'laneConstraints'" [ngStyle]="{'width' : col.width}" class="p-0">
                    <p-table [value]="getLanesForUnscheduled(rowData['runId'])" class="text-left">
                      <ng-template pTemplate="body" let-rowData>
              <tr>
                <td class="innerTableRowHeight">
                  {{rowData['laneId'] +': '+ rowData['constraintId']}}
                </td>
              </tr>
            </ng-template>
          </p-table>
          </td>
          <td *ngIf="col.field == 'laneDetails'" [ngStyle]="{'width' : col.width}" class="p-0">
            <p-table [value]="getLanesForUnscheduled(rowData['runId'])" class="text-left">
              <ng-template pTemplate="body" let-rowData>
                <tr>
                  <td class="p-0 innerTableRowHeight">
                    <div class="lane">
                      <div *ngFor="let laneBlock of rowData['laneBlocks']" style="display: inline-block;"
                        [ngStyle]="getLaneBlockStyle(laneBlock)">
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </td>
          <td *ngIf="col.field == 'runDuration'" [ngStyle]="{'width' : col.width}">
            {{getRunDuration(rowData['flowCellName'], rowData['largestReadMode'])}}
          </td>
          <td *ngIf="col.field == 'status'" [ngStyle]="{'width' : col.width}">
            {{rowData['status']}}
          </td>
          <td *ngIf="col.field == 'action'" [ngStyle]="{'width' : col.width}">
            <div class="col-12">
              <em class="fa fa-2x fa-calendar iconColor" (click)="getScheduledMatrix(rowData)" (keydown)="getScheduledMatrix(rowData)"></em>
            </div>
          </td>
          </ng-container>
          </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="unscheduledTableColumns?.length" class="text-center">
                No records found
              </td>
            </tr>
          </ng-template>
          </p-table>
          <p-paginator #unscheduledPP [rows]="40" (onPageChange)="paginateForUnscheduled($event)"
            totalRecords="{{unscheduledTotal}}" pageLinks="3"></p-paginator>
        </div>
      </div>
    </div>

    <div class="col-2">
      <div class="col-12 pt-0 legendBorder">
        <div class="col-12 text-center">
          Legend
        </div>
        <div class="col-12 flex paddingLeft">
          <div class="col-3 p-0 ml-1">
            <div class="legendBox legendPhix">

            </div>
          </div>
          <div class="col-6 p-0">
            PhiX
          </div>
        </div>
        <div class="col-12 flex paddingLeft">
          <div class="col-3 p-0 ml-1">
            <div class="legendBox legendOverdue">

            </div>
          </div>
          <div class="col-6 p-0">
            Overdue
          </div>
        </div>
        <div class="col-12 flex paddingLeft">
          <div class="col-3 p-0 ml-1">
            <div class="legendBox legendDueless">

            </div>
          </div>
          <div class="col-6 p-0">
            Due in &#60;=5 days
          </div>
        </div>
        <div class="col-12 flex paddingLeft">
          <div class="col-3 p-0 ml-1">
            <div class="legendBox legendDuemore">

            </div>
          </div>
          <div class="col-6 p-0">
            Due in &#62;5 days
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 p-0 mt-2">
    <p-confirmDialog appendTo="body" key="sendToNglims"></p-confirmDialog>
    <p-table class="text-center" [value]="scheduledTableData" [columns]="scheduledTableColumns" [scrollable]="true"
      [style]="{'overflow':'visible', 'word-wrap': 'break-word'}" [scrollHeight]="scheduledTableScrollheight"
      [loading]="scheduledTableLoading" (sortFunction)="sortscheduledTableData($event)" [customSort]="true">
      <ng-template pTemplate="caption">
        <table aria-describedby="table to format" style="border: none;">
          <thead>
            <th style="width: 17%;">
              <div class="ui-inputgroup flex">
                <button pButton class="theme-button labelButton" type="button" label="From"></button>
                <p-calendar class="datePicker1" [(ngModel)]="scheduledFromDate"
                  (onSelect)="getScheduledTableData(0, 40)" [disabled]="!selectedSequencerType" dateFormat="dd.mm.yy"
                  [style]="{'min-width':'133%'}" [inputStyle]="{'width':'100%'}"></p-calendar>
              </div>
            </th>
            <th style="width: 11%;">
              <div class="ui-inputgroup flex">
                <button pButton class="theme-button labelButton" type="button" label="To"></button>
                <p-calendar class="datePicker2" [(ngModel)]="scheduledToDate" (onSelect)="getScheduledTableData(0, 40)"
                  [disabled]="!selectedSequencerType" dateFormat="dd.mm.yy" [style]="{'min-width':'155%'}"
                  [inputStyle]="{'width':'100%'}"></p-calendar>
              </div>
            </th>
            <th>
              <label style="font-size: large;">Scheduled Data</label>
            </th>
            <th class="text-right">
              <em class="fa fa-search"></em>
              <input type="text" pInputText size="40" placeholder="Global Filter" [(ngModel)]="schduledfiltervalue"
                (input)="scheduleGlobalFilter($event.target.value)" style="width:auto">
            </th>
          </thead>
        </table>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th scope="col" *ngFor="let col of columns" class="text-center" [ngStyle]="{'width' : col.width}"
            [pSortableColumn]="col.field">
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [ngStyle]="getBorderStyle(rowData)">
          <ng-container *ngFor="let col of columns">
            <td *ngIf="col.field == 'runId'" [ngStyle]="{'width' : col.width}">
              <a [routerLink]="['/runprocess', rowData['runId']]">{{rowData['runId']}}</a>
            </td>
            <td *ngIf="col.field == 'flowcellConfig'" [ngStyle]="{'width' : col.width}">
              {{rowData['flowCellName'] + " " + rowData['largestReadMode']}}
            </td>
            <td *ngIf="col.field == 'laneConstraints'" [ngStyle]="{'width' : col.width}" class="p-0">
              <p-table [value]="getLanesForScheduled(rowData['runId'])" class="text-left">
                <ng-template pTemplate="body" let-rowData>
        <tr>
          <td class="innerTableRowHeight">
            {{rowData['laneId'] +': '+ rowData['constraintId']}}
          </td>
        </tr>
      </ng-template>
    </p-table>
    </td>
    <td *ngIf="col.field == 'laneDetails'" [ngStyle]="{'width' : col.width}" class="p-0">
      <p-table [value]="getLanesForScheduled(rowData['runId'])" class="text-left">
        <ng-template pTemplate="body" let-rowData>
          <tr>
            <td class="p-0 innerTableRowHeight">
              <div class="lane">
                <div *ngFor="let laneBlock of rowData['laneBlocks']" style="display: inline-block;"
                  [ngStyle]="getLaneBlockStyle(laneBlock)">
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </td>
    <td *ngIf="col.field == 'sequencerIntrument'" [ngStyle]="{'width' : col.width}">
      {{rowData['sequencerIntrument']}}
    </td>
    <td *ngIf="col.field == 'planDate'" [ngStyle]="{'width' : col.width}">
      {{getRunStartDate(rowData)}}
    </td>
    <td *ngIf="col.field == 'plannedFinishDate'" [ngStyle]="{'width' : col.width}">
      {{getRunFinishDate(rowData)}}
    </td>
    <td *ngIf="col.field == 'status'" [ngStyle]="{'width' : col.width}">
      {{rowData['status']}}
    </td>
    <td *ngIf="col.field == 'action'" [ngStyle]="{'width' : col.width}">
      <div class="col-6">
        <em *ngIf="['RUN_SCHEDULED', 'PREPARE_DATA_FOR_ANALYSIS'].includes(rowData['status'])"
          class="fa fa-2x fa-calendar-times-o iconColor" (click)="unscheduleRun(rowData)" (keypress)="unscheduleRun(rowData)"></em>
      </div>
      <div class="col-6">
        <em (click)="checkBeforeTransferToNglims(rowData)" (keypress)="checkBeforeTransferToNglims(rowData)" class="fa fa-2x fa-regular fa-arrow-right iconColor"></em>
        <br>
        NGLIMS
      </div>
    </td>
    </ng-container>
    </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="unscheduledTableColumns?.length" class="text-center">
          No records found
        </td>
      </tr>
    </ng-template>
    </p-table>
    <p-paginator #scheduledPP [rows]="40" (onPageChange)="paginateForscheduled($event)" totalRecords="{{scheduledTotal}}"
      pageLinks="3"></p-paginator>
  </div>
</div>

<p-sidebar [(visible)]="showScheduleSideBar" [baseZIndex]="10000" [dismissible]="false" [modal]="true"
  [style]="{'width':'45em', 'word-wrap': 'break-word'}">
  <div class="col-12">
    <p-table [value]="headerVal">
      <ng-template pTemplate="body">
        <tr>
          <td
            [ngStyle]="{'background-color': '#006B96', 'border-color': '#006B96', 'color':'white', 'font-size': 'larger', 'width': '70%'}">
            Sequencer Utilization - {{selectedSequencerType}}
          </td>
          <td [ngStyle]="{'width': '10%', 'background-color': '#e97474', 'border-color': '#e97474'}">
          </td>
          <td [ngStyle]="{'width': '10%', 'background-color': '#fdb872', 'border-color': '#fdb872'}">
          </td>
          <td [ngStyle]="{'width': '10%', 'background-color': '#6aa84f', 'border-color': '#6aa84f'}">
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="col-12" *ngIf="schedulingBlock">
    <div class="text-center">
      <div class="spinner-border text-primary" style="margin-top: 20rem; width: 7rem; height: 7rem;" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
  <div *ngIf="!schedulingBlock">
    <div class="col-12">
      <p-table [value]="scheduleMatrix" [columns]="scheduleDateList">
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr>
            <ng-container *ngFor="let col of columns">
              <td *ngIf="col == 'machine'"
                [ngStyle]="{'width':'18%', 'border':'1px solid black', 'font-weight':'bold', 'cursor': 'pointer'}"
                (click)="useMachineToSuggest(rowData.get('machine'))" (keypress)="useMachineToSuggest(rowData.get('machine'))">
                {{rowData.get('machine')}}
              </td>
              <td *ngIf="col != 'machine'" [ngStyle]="getStyle(rowData.get(col))" [pTooltip]="col"
                tooltipPosition="right" tooltipZIndex="100000" (click)="useDayToVerify(col, rowData.get('machine'))" (keypress)="useDayToVerify(col, rowData.get('machine'))">
              </td>
            </ng-container>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="col-12">
      <p-table [value]="headerVal">
        <ng-template pTemplate="body">
          <tr>
            <td
              [ngStyle]="{'background-color': '#006B96', 'border-color': '#006B96', 'color':'white', 'font-size': 'larger', 'width': '100%'}">
              Scheduler
            </td>
          </tr>
          <tr>
          </tr>
        </ng-template>
      </p-table>

      <div class="col-12" style="height: 3em">
        <div class="col-12 text-center font-weight-bold" *ngIf="showSlotErrorMessage" [ngStyle]="getFontColor()">
          {{schedulingMessage}}
        </div>
      </div>

      <div class="col-12 p-0 mt-2">
        <div class="ui-inputgroup mt-2">
          <button pButton class="theme-button labelButtonScheduler" type="button" label="Run"></button>
          <input class="inputFields" type="text" pInputText [value]="runIdToBeScheduled" readonly>
        </div>
        <div class="ui-inputgroup mt-2">
          <button pButton class="theme-button labelButtonScheduler" type="button" label="Sequencer"></button>
          <p-dropdown [style]="{'width':'15em', 'maxWidth':'15em'}" [options]="sequencers"
            [(ngModel)]="selectedSequencer" (onChange)="suggestSlotForMachine()"></p-dropdown>
        </div>
        <div class="mt-4">
          <p-fieldset legend="Timeslot" class="mt-2">
            <div class="ui-inputgroup">
              <button pButton class="theme-button labelButtonScheduler" type="button" label="Planned Start"></button>
              <p-calendar [inputStyle]="{'width':'12.8em'}" [(ngModel)]="selectedTimeSlotStart" dateFormat="dd.mm.yy"
                [minDate]="minDate" [maxDate]="maxDate" [showTime]="true" (onClose)="calculateEndDateTime()"
                (onClick)="calculateEndDateTime()" (onBlur)="calculateEndDateTime()"></p-calendar>
            </div>
            <div class="ui-inputgroup mt-2">
              <button pButton class="theme-button labelButtonScheduler" type="button" label="Expected Finish"></button>
              <input style="width: 11.5rem; border: 1px solid #D6D6D6; padding-left: 0.5em;"
                [value]="getDisplay(selectedTimeSlotEnd)" readonly />
            </div>
          </p-fieldset>

          <div class="text-center mt-2">
            <p-button icon="pi pi-check" label="Validate" (onClick)="validateSlot()" [disabled]="isValidateDisabled()">
            </p-button>
            <p-button icon="pi pi-check" label="Save" (onClick)="saveRun()" [disabled]="isSaveDisabled()"></p-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-sidebar>